// extracted by mini-css-extract-plugin
export default {"title":"lookupTitle_title__UrrN6"};